export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center pt-[64px] md:pt-[72px] bg-gradient-to-br from-background-50 via-background-100/80 to-primary-50/40"
    >
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4 whitespace-nowrap">
              每日更新 · 高清不缓冲
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              被窝网电影<span className="text-primary-600"> · </span>大全高清免费在线观看
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-medium mb-4">
              热门电影电视剧资源聚合，最新全集不缓冲流畅播放
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              被窝网电影大全是一个专注高清影视资源聚合的在线观影平台，每日同步更新院线大片、热门电视剧、综艺动漫等优质内容。
              无需下载、即点即播，全站采用智能加载技术保障流畅体验，让你在被窝里也能畅享极致观影。
              当前平台已收录超两万部影视作品，涵盖动作、喜剧、悬疑、爱情、科幻等全品类，是影迷发现好片的不二之选。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">
                  <strong className="text-accent-600 font-semibold">20,000+</strong> 部影视资源
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">
                  <strong className="text-primary-600 font-semibold">每日更新</strong> 最新剧集
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-secondary-500 animate-pulse"></span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">
                  <strong className="text-secondary-700 font-semibold">全端适配</strong> 手机电脑平板
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium rounded-lg hover:bg-background-100 hover:border-primary-300 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20collage%20with%20film%20reels%20and%20soft%20golden%20lighting%2C%20elegant%20home%20theater%20aesthetic%20with%20cozy%20blanket%20and%20popcorn%2C%20modern%20streaming%20device%20on%20wooden%20table%2C%20ambient%20warm%20glow%2C%20artistic%20photography%20with%20shallow%20depth%20of%20field%2C%20rich%20textures%20and%20inviting%20atmosphere%2C%20clean%20composition&width=800&height=600&seq=hero-movie-01&orientation=landscape"
                alt="被窝网电影 - 高清影视在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}